import { Text } from '@doordash/design-language'
import * as React from 'react'

const LegalText: React.SFC = props => (
  <Text
    styles={Text.Styles.LegalTextMedium}
    lineHeight={Text.LineHeights.Medium}
    {...props}
  >
    {props.children}
  </Text>
)

export default LegalText
